export default __webpack_public_path__ + "static/media/slide4.bc928674.mp3";